__turbopack_context__.v({
  "cardSection": "HomePageClient-module__-PIEnq__cardSection",
  "cryptoHeading": "HomePageClient-module__-PIEnq__cryptoHeading",
  "cryptoSection": "HomePageClient-module__-PIEnq__cryptoSection",
  "cryptoSubtitle": "HomePageClient-module__-PIEnq__cryptoSubtitle",
  "cryptoTitle": "HomePageClient-module__-PIEnq__cryptoTitle",
  "sectionHeader": "HomePageClient-module__-PIEnq__sectionHeader",
  "sectionTitle": "HomePageClient-module__-PIEnq__sectionTitle",
  "viewAllButton": "HomePageClient-module__-PIEnq__viewAllButton",
});
